module.exports = __webpack_public_path__ + "static/media/g-11.d9f583b4.jpg";